import { AnimatePresence, motion } from 'framer-motion';
import { useEffect, useMemo } from 'react';
import { GameViewport } from './components/GameViewport';
import { RenderErrorBoundary } from './components/RenderErrorBoundary';
import { useSimulationEngine } from './hooks/useSimulationEngine';
import { loadGame, startAutoSave } from './save/gameSave';
import { registerServiceWorker } from './save/serviceWorker';
import { useGameStore } from './simulation/store';
import { HUD } from './ui/HUD';
import { Inspector } from './ui/Inspector';
import { Toolbar } from './ui/Toolbar';
import { WelcomePanel } from './ui/WelcomePanel';

export default function App() {
  useSimulationEngine();

  const hydrated = useGameStore((state) => state.hydrated);
  const hasSeenWelcome = useGameStore((state) => state.hasSeenWelcome);
  const markWelcomeSeen = useGameStore((state) => state.markWelcomeSeen);

  useEffect(() => {
    void loadGame();
    registerServiceWorker();
  }, []);

  useEffect(() => startAutoSave(), []);

  const showWelcome = useMemo(() => hydrated && !hasSeenWelcome, [hasSeenWelcome, hydrated]);

  return (
    <main className="relative min-h-screen overflow-hidden bg-hive-cream text-hive-ink">
      <RenderErrorBoundary>
        <GameViewport />
      </RenderErrorBoundary>
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_20%_12%,rgba(246,234,209,.35),transparent_24%),linear-gradient(180deg,rgba(246,234,209,.35),rgba(23,38,56,.08))]" />
      <HUD />
      <Toolbar />
      <Inspector />
      <AnimatePresence>
        {showWelcome ? (
          <motion.div
            className="pointer-events-auto absolute inset-0 z-40 grid place-items-center bg-hive-night/30 px-4 backdrop-blur-sm"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <WelcomePanel onClose={markWelcomeSeen} />
          </motion.div>
        ) : null}
      </AnimatePresence>
    </main>
  );
}
